import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styled from 'styled-components';

type AccordionPanelProps = React.PropsWithChildren<{
  title: string;
  isExpanded: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  className?: 'accordion-paper-content';
}>;

export function AccordionPanel(props: AccordionPanelProps): JSX.Element {
  const {
    title,
    isExpanded,
    onExpandedChange = () => {},
    className,
    children,
  } = props;

  const handleExpandedChange = (
    _: React.SyntheticEvent,
    expanded: boolean,
  ): void => {
    onExpandedChange(expanded);
  };

  return (
    <StyledAccordion
      className={className}
      expanded={isExpanded}
      onChange={handleExpandedChange}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Header>{title}</Header>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  );
}

const Header = styled(Typography).attrs({
  component: 'h2',
  variant: 'h6',
})`
  color: ${({ theme }) => theme.color.text.primary};
  font-family: ${({ theme }) => theme.font.family.heading};
  &.MuiTypography-root {
    font-weight: 600;
  }
`;

const StyledAccordion = styled(Accordion)`
  &.accordion-paper-content {
    &.MuiAccordion-root {
      background-color: #1f3e3f;
      border-radius: 4px;
      width: 100%;
      & .MuiAccordionSummary-root {
        min-height: 32px;
        &.Mui-expanded .MuiSvgIcon-root {
          color: ${({ theme }) => theme.color.main.primary};
        }
        &.Mui-expanded .MuiTypography-root {
          color: ${({ theme }) => theme.color.main.primary};
          font-weight: 500;
        }
      }
      & .MuiAccordionDetails-root {
        max-height: max-content;
      }
    }
  }
`;
